import { createRoute } from '@tanstack/react-router';
import { labExpiredParentRoute } from 'pages/lab/labParentRoute';
import {
  pageResetMiddleWare,
  zodOptionalDateRange,
  zodOptionalIdArray,
  zodPage,
} from 'routes/routeUtils';
import { z } from 'zod';

const baseLabExpiredProductsRequestsStatusSchema = z.enum([
  'ongoing',
  'awaiting_signing',
  'signed_by_pharmacy',
  'validated_by_lab',
  'refused_by_lab',
]);

const labExpiredProductsRequestsSearchSchema = z.object({
  query: z.string().optional(),
  groupIds: zodOptionalIdArray,
  salesRepIds: zodOptionalIdArray,
  regionalDirectorIds: zodOptionalIdArray,
  pharmacyIds: zodOptionalIdArray,
  status: z
    .tuple([baseLabExpiredProductsRequestsStatusSchema], baseLabExpiredProductsRequestsStatusSchema)
    .optional(),
  validatedAtRange: zodOptionalDateRange,
  createdAtRange: zodOptionalDateRange,
  tab: z
    .enum([
      'ongoing',
      'awaiting_signing',
      'signed_by_pharmacy',
      'validated_by_lab',
      'refused_by_lab',
      'draft',
      'all',
    ])
    .default('signed_by_pharmacy'),
  page: zodPage,
});

export type LabExpiredProductsRequestsSearchType = z.infer<
  typeof labExpiredProductsRequestsSearchSchema
>;

export const labExpiredProductsRequestsRoute = createRoute({
  getParentRoute: () => labExpiredParentRoute,
  path: '/list',
  validateSearch: labExpiredProductsRequestsSearchSchema,
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import(
    'pages/lab/ExpiredProductsRequests/LabExpiredProductsRequestsPage/LabExpiredProductsRequestsPage'
  ).then((d) => d.Route)
);
